<template>
  <BCard class="border p-0 col">
    <BOverlay
      :show="loading"
      spinner-variant="primary"
      variant="light"
      blur="0"
      opacity="0.7"
      rounded="sm"
    >
      <div class="d-flex flex-column">
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex justify-content-start gap-5 align-items-center">
            <div
              class="p-[3px] rounded"
              :class="classIcon"
            >
              <img
                :src="icon"
                alt="revenue"
                width="20px"
              >
            </div>
            <span class="text-[15px] text-[#626262]">{{ title }}</span>
          </div>
          <div class="d-flex justify-content-end col-6 p-0">
            <BButton
              :id="`periode-${value}`"
              variant="outline-secondary"
              class="lg:max-w-[150px] lg:min-w-[120px] p-1 text-left d-flex justify-content-between align-items-center"
              style="height: 37px !important;"
              @click="popoverShow = !popoverShow"
            >
              <span class="text-nowrap truncate ">{{ lableButton }}</span>
              <img
                :src="popoverShow ? 'https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/arrow-up-2.svg' : 'https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/arrow-down-1.svg'"
                alt="arrow"
                width="15px"
              >
            </BButton>
            <BPopover
              id="periode-list"
              :target="`periode-${value}`"
              placement="bottom"
              triggers="manual"
              :show.sync="popoverShow"
            >
              <ul style="margin: -8px -10px -8px -10px;">
                <li
                  v-for="(item, idx) in optionsDate"
                  :key="idx"
                >
                  <BButton
                    class="w-100 text-left"
                    variant="light"
                    @click="getData(item.value); popoverShow = false;"
                  >
                    {{ item.text }}
                  </BButton>
                </li>
                <li>
                  <date-range-picker
                    ref="picker"
                    v-model="dateRange"
                    :locale-data="locale"
                    :ranges="ranges"
                    :opens="'left'"
                    control-container-class="border-0"
                    class="w-100"
                    @update="getData(value, 'custom')"
                  >
                    <template v-slot:input="picker">
                      <BButton
                        class="w-100 text-left"
                        variant="light"
                      >
                        Date Picker
                      </BButton>
                      <span class="d-none">{{ picker }}</span>
                    </template>
                  </date-range-picker>
                </li>
              </ul>
            </BPopover>
          </div>
        </div>
        <div class="d-flex align-items-center gap-5 mt-1">
          <span class="text-black text-[24px] font-semibold">
            {{ dataAnalytic && dataAnalytic.total != null ? parseFloat(dataAnalytic.total.toFixed(2)) : 0 }}<span
              v-if="value === 'retention_user'"
            >%</span>
          </span>
          <span class="increased text-[12px] px-[10px] py-[4px] rounded rounded-pill text-nowrap">
            <span v-if="countTitle === 'Last Week'">{{ getMinPlus(dataAnalytic && dataAnalytic.this_week != null ?
              dataAnalytic.this_week : 0) }}</span>
            <span v-else>{{ getMinPlus(dataAnalytic && dataAnalytic.this_month != null ? dataAnalytic.this_month : 0)
            }}</span>
            {{ countTitle === 'Last Week' ? (dataAnalytic && dataAnalytic.this_week != null ?
              parseFloat(dataAnalytic.this_week.toFixed(2)) : 0) : (dataAnalytic && dataAnalytic.this_month != null ?
              parseFloat(dataAnalytic.this_month.toFixed(2)) : 0) }}<span v-if="value === 'retention_user'">%</span> {{
              percenTitle }}</span>
        </div>
        <span class="text-[#626262] mt-2">{{ countTitle }} : {{ countTitle === 'Last Week' ? (dataAnalytic &&
          dataAnalytic.last_week != null ? dataAnalytic.last_week : 0) : (dataAnalytic && dataAnalytic.last_month !=
          null ? parseFloat(dataAnalytic.last_month.toFixed(2)) : 0) }}</span>
      </div>
    </BOverlay>
  </BCard>
</template>
<script>

import {
  BPopover,
} from 'bootstrap-vue'
import { LABELDAY, LABELMONTH, YEAR_MONTH_DAY } from '@/libs/filterDate'
import {
  today,
  last7,
  last2,
  last30,
  firstDateOfMonth,
  lastDateOfMonth,
  lastMonth,
  lastDateOfLastMonth,
} from '@/store/helpers'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import '@core/scss/vue/libs/vue-select.scss'

export default {
  components: {
    DateRangePicker,
    BPopover,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    countTitle: {
      type: String,
      required: true,
    },
    percenTitle: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    classIcon: {
      type: String,
      required: true,
    },
    dataAnalytic: {
      type: Object,
      default: () => null,
      required: true,
    },
    loading: {
      type: Boolean,
      reqired: true,
      default: true,
    },
    isAllTime: {
      type: Boolean,
      reqired: true,
      default: false,
    },
    optionsDate: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  data() {
    return {
      YEAR_MONTH_DAY,
      picker: {
        startDate: firstDateOfMonth,
        endDate: lastDateOfMonth,
      },
      locale: {
        format: 'dd/mm/yyyy',
        daysOfWeek: LABELDAY,
        monthNames: LABELMONTH,
      },
      ranges: {
        'This Month': [firstDateOfMonth, today],
        'Last 30 Days': [last30, today],
        'Last Month': [lastMonth(1), lastDateOfLastMonth],
        'Last 2 Months': [lastMonth(2), lastDateOfLastMonth],
        'Custom Range': [today, today],
      },
      today,
      last7,
      last2,
      last30,
      firstDateOfMonth,
      lastDateOfMonth,
      dateRange: {
        startDate: last30,
        endDate: today,
      },
      dateRevenue: 'this_month',
      popoverShow: false,
      lableButton: 'This Month',
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    handleClickOutside(event) {
      const mainPopover = document.getElementById('periode-list')
      const button = document.getElementById(`periode-${this.value}`)
      const datePickPopover = document.getElementById(`date-pick-${this.value}`)

      if (
        mainPopover && !mainPopover.contains(event.target)
      && button && !button.contains(event.target)
      && (!datePickPopover || !datePickPopover.contains(event.target))
      ) {
        this.popoverShow = false
      }
    },
    getData(value, e) {
      if (e === 'custom') {
        this.$emit('getDataAnalytic', this.value, e, this.dateRange.startDate, this.dateRange.endDate)
        this.lableButton = 'Custom Range'
      } else {
        this.$emit('getDataAnalytic', this.value, this.optionsDate.find(item => item.value === value).value)
        this.lableButton = this.optionsDate.find(item => item.value === value).text
      }
      this.popoverShow = false
    },
    getMinPlus(value) {
      if (value < 0) return '-'
      return '+'
    },
  },
}
</script>
<style scoped>
.decreased {
    background-color: #FCBEBE;
    color: #E31A1A;
    width: fit-content;
}
.increased {
    background-color: #BEFCDE;
    color: #34A770;
    width: fit-content;
}
</style>
